/* unplugin-vue-components disabled */import script from "./MarketTransactionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketTransactionCard.vue?vue&type=script&setup=true&lang=js"

import "./MarketTransactionCard.vue?vue&type=style&index=0&id=a4634758&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4634758"]])

export default __exports__